import React, { ReactElement } from 'react';

export const ChevronLeft = ({
    strokeColour = '#A0A4A8',
    className = '',
}: {
    strokeColour?: string;
    className?: string;
}): ReactElement => {
    return (
        <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M6.5 11L1.5 6L6.5 1"
                stroke={strokeColour}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
